import {
  type Breadcrumb,
  BreadcrumbListSchema,
} from 'store/schemas/BreadcrumbList';
import { NewsArticleSchema } from 'store/schemas/NewsArticle';
import { Schema } from 'store/schemas/Schema';

type AboutSchema =
  | {
      type: 'Thing';
      name: string;
    }
  | {
      type: 'SportsEvent';
      name: string;
      sport: string;
    };

interface ICollectionPageSchema {
  name: string;
  description: string;
  url: string;
  mainEntity: {
    name: string;
    list: {
      headline: string;
      url: string;
      image?: string | null;
      datePublished: string;
    }[];
  };
  about?: AboutSchema;
  breadcrumb?: Breadcrumb[];
}

export class CollectionPageSchema extends Schema {
  name;
  description;
  url;
  breadcrumb;
  about;
  mainEntity;

  constructor({
    name,
    description,
    url,
    breadcrumb,
    about,
    mainEntity,
  }: ICollectionPageSchema) {
    super();
    this.name = name;
    this.description = description;
    this.url = url;
    this.breadcrumb = breadcrumb;
    this.about = about;
    this.mainEntity = mainEntity;
  }

  toJSON() {
    return Schema.cleanse({
      '@context': 'http://schema.org',
      '@type': 'CollectionPage',
      name: this.name,
      description: this.description,
      url: this.url,
      breadcrumb: new BreadcrumbListSchema({ list: this.breadcrumb }).toJSON(),
      about: this.about,
      mainEntity: {
        '@type': 'ItemList',
        name: this.mainEntity.name,
        itemListElement: this.mainEntity.list.map((item) =>
          new NewsArticleSchema(item).toJSON(),
        ),
      },
    });
  }
}
